import { SET_ASSETS } from './commonTypes'

const initialState = {
  loading: false,
  assets: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ASSETS:
      return {
        ...state,
        assets: action.payload,
      }

    default:
      return state
  }
}
